import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export default css`
  .empty-card-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    height: 231px;
    max-width: 770px;
    background-color: white;
    border-radius: 8px;
  }

  @media screen and (min-width: ${screen.smMin}) {
    .empty-card-container {
      height: 207px;
    }
  }

  .empty-card {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .empty-card-image {
    margin-bottom: 12px;
  }

  .gray-heart-icon {
    width: 30px;
    height: 28px;
  }

  .bar-chart-icon {
    width: 40px;
    height: 32px;
  }

  .empty-card-label {
    font-weight: 600;
    font-size: 20px;
    color: ${colors.BLACK};
    margin-bottom: 8px;
  }

  .empty-card-content {
    max-width: 370px;
    font-size: 16px;
    color: ${colors.G3};
    padding: 0 24px;
    text-align: center;
  }
`;
